/**
 * Safely extract a human-readable error message from an axios error.
 *
 * Handles FastAPI response shapes:
 *   - 4xx/5xx with { detail: "Some string" }
 *   - 422 Pydantic validation: { detail: [{ type, loc, msg, input, ctx }, ...] }
 *   - { message: "..." } / { msg: "..." }
 *
 * Always returns a string so it is safe to render as a React child / pass to
 * sonner's toast.error().
 */
export function extractErrorMessage(error, fallback = 'An error occurred. Please try again.') {
  const data = error?.response?.data;
  if (!data) return error?.message || fallback;

  const detail = data.detail;

  // Pydantic validation errors come back as an array of objects.
  if (Array.isArray(detail)) {
    const first = detail[0];
    if (first && typeof first === 'object' && typeof first.msg === 'string') {
      return first.msg;
    }
    return fallback;
  }

  if (typeof detail === 'string') return detail;
  if (typeof data.message === 'string') return data.message;
  if (typeof data.msg === 'string') return data.msg;

  return fallback;
}
